import { getOrderOperationTips } from 'utils/getOrderNotifyMsg'
import Notification from 'com/Notification'
import Modal from 'com/Modal'
import { CURRENCY_TYPE, ORDER_TYPE, TIME_IN_FORCE } from 'const/trade'
import { mapGetters } from 'vuex'
import * as types from 'store/mutation-types'
import orderValidateMixin from 'mixins/orderValidateMixin'

export default {
  mixins: [orderValidateMixin],
  data() {
    return {
      showTradePassword: false,
      showOrderConfirm: false,
      callbackOnPwd: 'check' // 输入密码后的回调
    }
  },
  computed: {
    ...mapGetters([
      'isCash',
      'isMarsco',
      'isIb',
      'isVirtual',
      'asset',
      'isDeposited'
    ]),
    order() {
      const order = {
        symbol: this.stock.symbol,
        market: this.stock.market,
        secType: this.stock.secType,
        multiplier: this.stock.multiplier || 1,
        timeInForce: TIME_IN_FORCE.DAY,
        outsideRth: false,
        currency: this.isHK ? CURRENCY_TYPE.HK : CURRENCY_TYPE.US,
        orderType: this.confirmOrder.orderType || ORDER_TYPE.MKT,
        limitPrice: this.confirmOrder.limitPrice,
        action: this.confirmOrder.action || 'BUY',
        totalQuantity: this.confirmOrder.isCloseout
          ? this.confirmOrder.position
          : this.quantity
      }
      if (this.confirmOrder.orderId) {
        order.orderId = this.confirmOrder.orderId
      }
      if (this.isOPT) {
        order.expiry = this.stock.expiry
        order.strike = this.stock.strike
        order.right = this.stock.right
      }
      return order
    }
  },
  methods: {
    newOrder(data) {
      if (!this.isDeposited) return this.$emit('showAccountStatus')
      Object.assign(this.confirmOrder, data)
      this.confirmOrder.type = 'create'
      this.validateOrder(this.previewOrder)
    },
    cancelOrder(data) {
      const { order, orderIds } = data
      this.confirmOrder.orderType = order.orderType
      this.cancelOrder.action = order.action
      this.confirmOrder.limitPrice = order.limitPrice
      this.confirmOrder.isCloseout = false
      this.confirmOrder.cancelIds = orderIds
      this.confirmOrder.type = 'cancel'
      if (this.confirmOrder.cancelIds.length === 1) {
        this.previewOrder()
      }
      if (this.confirmOrder.cancelIds.length > 1) {
        Modal.open({
          wrapClassName: 'trade-warning-modal',
          title: this.$t('trade.trade-warning-title'),
          content: this.$t('trade.dom.cancel-all', {
            price: this.highlight(this.confirmOrder.limitPrice),
            action: this.highlight(
              this.$t(
                `trade.dom.order-${this.confirmOrder.action.toLowerCase()}`
              )
            )
          }),
          onConfirm: () => {
            this.confirmCancelOrder()
          }
        })
      }
    },
    previewOrder() {
      this.$store
        .dispatch('checkOrder', this.order)
        .then(() => {
          this.showOrderConfirm = true
        })
        .catch(err => {
          if (err.isNeedReOrder) this.showTradePwd('check')
        })
    },
    submitOrder() {
      if (this.confirmOrder.type === 'create') {
        this.confirmNewOrder()
      }
      if (this.confirmOrder.type === 'cancel') {
        this.confirmCancelOrder()
      }
    },
    confirmNewOrder() {
      this.$store
        .dispatch('newOrder', this.order)
        .then(() => {
          this.notify(true)
          this.getStockHoldingsAndOrders()
          this.getNewIbOrderId()
        })
        .catch(err => {
          if (err.isNeedReOrder) {
            this.showTradePwd('confirm')
          }
        })
    },
    confirmCancelOrder() {
      return Promise.all(
        this.confirmOrder.cancelIds.map(id => {
          return this.$store.dispatch('cancelOrder', id)
        })
      )
        .then(() => {
          this.cancelConfirmed = false
          this.getStockHoldingsAndOrders()
          this.confirmOrder.type = 'create'
          this.confirmOrder.cancelIds = []
        })
        .catch(error => {
          if (error.isNeedReOrder) {
            this.showTradePwd('confirm')
          } else {
            this.notify(false)
          }
        })
    },
    closeTradePassword(success) {
      this.showTradePassword = false
      if (success) {
        if (this.callbackOnPwd === 'check') return this.previewOrder()
        this.submitOrder()
      }
    },
    closeOrderConfirm(success) {
      this.showOrderConfirm = false
      if (success) this.submitOrder()
    },
    showTradePwd(call) {
      // 订单提交后token过期，取消本地缓存，避免一直提交订单后在提示交易面
      this.callbackOnPwd = call
      this.showTradePassword = true
      this.$store.commit(types.UPDATE_USER_TRADE_TOKEN, '')
    },
    notify(isSuccess) {
      const data = getOrderOperationTips(
        this.order,
        this.confirmOrder.type,
        isSuccess
      )
      Notification.open(data)
    }
  }
}
